module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Regular TH.8dc43bd6.woff2";